import React from "react";
import { Header } from "../components/Header";
import { Balance } from "../components/Balance";
import { IncomeExpenses } from "../components/IncomeExpenses";
import { TransactionList } from "../components/TransactionList";
import { AddTransaction } from "../components/AddTransaction";
import { FETCH_TRANSACTIONS_QUERY } from "../graphql";
import { useQuery } from "@apollo/client";
import { SimpleGrid, Box } from "@chakra-ui/react";

export default function Leon() {
  const { loading, error, data } = useQuery(FETCH_TRANSACTIONS_QUERY);
  if (loading) return "Loading...";
  if (error) return `Error! ${error.message}`;

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const allMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const startOfMonth = new Date(`${currentYear}, ${currentMonth + 1}, 1`);

  const transactions = data.getTransactions.filter((t) => t.user === "Leon");

  const filteredTransactinos = transactions.filter(
    (t) => new Date(t.createdAt) > startOfMonth
  );

  const transactionSort = [...filteredTransactinos];

  return (
    <>
      <SimpleGrid columns={3} spacingX="100px" spacingY="20px">
        <Box height="80px" w="80%"></Box>
        <Box height="80px" margin-left="10">
          <Header name="Leon" />
          <div className="container">
            <h1>{allMonths[currentMonth]}</h1>
            <Balance transactions={transactionSort} time="Month"/>
            <IncomeExpenses transactions={transactionSort} />
            <AddTransaction user="Leon" />
          </div>
        </Box>
        <Box height="80px" w="80%">
          <TransactionList transactions={transactionSort} />
        </Box>
      </SimpleGrid>
    </>
  );
}
